import GameData from "../model/GameData";
import {
  CargoCosts,
  CargoWeight,
  DayOrders,
  DAYS_IN_YEAR,
  EMPTY_TRAIN_CAR_TYPE,
  GetBrigadeSalary,
  GetPathLength,
  GetSecurityExpanses,
  LOCO_WEIGHT,
  LocoCards,
  PathCards,
  RepairValue,
  SecurityCards,
  StationCards,
  TRAIN_CAR_CARD_MAX_CARS,
  Variables
} from "../model/Balance";
import {
  DAY_NAMES,
  ELECTRO_TYPE,
  GAME_STATE_NAMES,
  GET_ELECTRICITY_COST,
  GET_FUEL_COST,
  INFRA_TYPE,
  LOCO_TYPE,
  STATION_NAMES
} from "../../constants/Constants";
import agent from "../../agent";

const GameController = {
  "startYear": () => {
    //Calc Debet/Credit
    GameData.CurrentGame.cash = GameData.CurrentGame.cash + GameData.CurrentGame.debet - GameData.CurrentGame.creditors;
    GameData.CurrentGame.debet = 0;
    GameData.CurrentGame.creditors = 0;


    if (GameData.CurrentGame.year !== 0) { //Start other year than first
      //TODO: Tednders
    }
    GameData.CurrentGame.state = 1;
  }, "startMorning": () => {
    let today = DayOrders[GameData.CurrentGame.day];
    let tomorrow = DayOrders[GameData.CurrentGame.day + 1] || [];
    let allOrdersNeeded = [...today, ...tomorrow];
    GameData.CurrentGame.addOrders(allOrdersNeeded);
    //Get Work Chips
    for (let i = 0; i < GameData.CurrentGame.stations.length; i++) {
      GameData.CurrentGame.stations[i].renew();
    }
    for (let i = 0; i < GameData.CurrentGame.repairShops.length; i++) {
      GameData.CurrentGame.repairShops[i].renew();
    }
    GameData.CurrentGame.dispetcher.renew();
    //Station Card Effect
    let card = StationCards[Math.floor(Math.random() * StationCards.length)];
    GameData.CurrentGame.currentStationCard = card;
    if (!card.isLucky) {
      GameController.processStationCard(card);
      console.log(`Processed card ${card.type} ${card.id} ${card.value}`)
    }
    //Trains on stations
    let paths = GameData.CurrentGame.paths;
    for (let i = 0; i < paths.length; i++) {
      let locoPathPlaces = paths[i].locoPlaces;
      for (let j = 0; j < locoPathPlaces.length; j++) {
        let locoPlace = locoPathPlaces[j];
        if (locoPlace.currentTrainIDs.length > 0) {
          for (let i = 0; i < locoPlace.currentTrainIDs.length; i++) {
            let id = locoPlace.currentTrainIDs[i];
            GameController.processTrains(paths[i], locoPlace, GameData.CurrentGame.getTrainById(id));
          }
          locoPlace.currentTrainIDs = [];
        }
      }
    }

    GameData.CurrentGame.state = 2;
  }, "startDay": () => {
    let stations = GameData.CurrentGame.stations;
    for (let i = 0; i < stations.length; i++) {
      let station = stations[i];
      let available = station.trainCarsPacks.filter(pack => !GameData.CurrentGame.getTrainCarById(pack).isPreparing);
      let unload = station.trainCarsPacks.filter(pack => GameData.CurrentGame.getTrainCarById(pack).isPreparing);
      for (let j = 0; j < station.orderTrainPacks.length; j++) {
        let orderPack = GameData.CurrentGame.getOrderTrainCarById(station.orderTrainPacks[j]);
        let trainCarCount = orderPack.trainCarCount;
        while (trainCarCount > 0) {
          if (trainCarCount > 20) {
            let pack = GameData.CurrentGame.createTrainCar(20, orderPack.type, orderPack.client, orderPack.orderCode);
            available.push(pack.id);
            trainCarCount -= 20;
          } else {
            let pack = GameData.CurrentGame.createTrainCar(trainCarCount, orderPack.type, orderPack.client, orderPack.orderCode);
            console.log(pack)
            available.push(pack.id);
            trainCarCount = 0;
          }
        }
        orderPack.trainCarCount = 0;
      }
      console.log(available)
      station.trainCarsPacks = available;
      for (let j = 0; j < unload.length; j++) {
        let pack = unload[j];
        GameData.CurrentGame.addMoneyForOrder(pack.trainCarCount * Variables.trainCarLiftingCapacity * CargoCosts[pack.type] * 365 / DAYS_IN_YEAR);
        station.trainCars += pack.trainCarCount;
        GameData.CurrentGame.exp += 1;
        GameData.CurrentGame.nps += 2;
      }
    }
    GameData.CurrentGame.state = 3;
  }, "startEvening": () => {
    let infraShop = GameData.CurrentGame.getRepairShopByType(INFRA_TYPE);
    let paths = GameData.CurrentGame.paths;

    for (let i = 0; i < paths.length; i++) {
      let path = paths[i];
      path.state += path.forRepairChips;
      path.breakDownChips += path.forRepairBreawdownChips;
      infraShop.parts -= path.forRepairChips + path.forRepairBreawdownChips;
      infraShop.brigadesChips -= path.forRepairChips + path.forRepairBreawdownChips;
      path.forRepairChips = 0;
      path.forRepairBreawdownChips = 0;
    }

    GameData.CurrentGame.onDataUpdated();
    GameData.CurrentGame.state = 4;
  }, "startLateEvening": () => {
    let paths = GameData.CurrentGame.paths;

    for (let i = 0; i < paths.length; i++) {
      let path = paths[i];
      path.state -= GameController.calcPathTrains(path);
    }

    //Path
    let card = PathCards[Math.floor(Math.random() * PathCards.length)];
    GameData.CurrentGame.currentPathCard = card;
    console.log(card)
    if (!card.isLucky) {
      GameController.processPathCard(card);
      console.log(`Processed card ${card.pathID} ${card.isLucky}`)
    }
    //Loco
    card = GameController.getLocoCard(GameData.CurrentGame.day, GameData.CurrentGame.year);
    console.log(card)
    GameData.CurrentGame.currentLocoCard = card;
    if (!card.isLucky) {
      GameController.processLocoCard(card);
    }
    //Security
    card = SecurityCards[Math.floor(Math.random() * SecurityCards.length)];
    GameData.CurrentGame.currentSecurityCard = card;
    console.log(card)
    if (!card.isLucky) {
      GameController.processSecurityCard(card);
      console.log(`Processed card ${card.type} ${card.id} ${card.value}`)
    }

    GameData.CurrentGame.state = 5;
  }, "endDay": () => {
    let paths = GameData.CurrentGame.getPaths();
    for (let i = 0; i < paths.length; i++) {
      paths[i].endDayBreakdownChips = 0;
    }
    //Repair Loco on Last Repair Stage
    let locomotives = GameData.CurrentGame.getRepairingLocomotives();
    for (let i = 0; i < locomotives.length; i++) {
      let loco = locomotives[i];
      loco.isReparing = false;
    }
    let electroShop = GameData.CurrentGame.getRepairShopByType(ELECTRO_TYPE);
    let lastStage = electroShop.stages[electroShop.stages.length - 1];
    for (let i = 0; i < lastStage.length; i++) {
      let loco = GameData.CurrentGame.getLocoById(lastStage[i]);
      loco.state = 10;
    }
    electroShop.stages[electroShop.stages.length - 1] = [];

    let locoShop = GameData.CurrentGame.getRepairShopByType(LOCO_TYPE);
    lastStage = locoShop.stages[locoShop.stages.length - 1];
    for (let i = 0; i < lastStage.length; i++) {
      let loco = GameData.CurrentGame.getLocoById(lastStage[i]);
      loco.state = 10;
    }
    locoShop.stages[electroShop.stages.length - 1] = [];

    //Clear chips and contractors
    let stations = GameData.CurrentGame.stations;
    for (let i = 0; i < stations.length; i++) {
      stations.contractors = 0;
      stations.brigadesChips = 0;
    }

    if (GameData.CurrentGame.day === 3) {
      GameData.CurrentGame.day = 0;
      GameData.CurrentGame.state = 0;
      GameData.CurrentGame.year++;
    } else {
      GameData.CurrentGame.day++;
      GameData.CurrentGame.state = 1;
    }
  }, getLocoCard: (day, year) => {
    console.log(LocoCards)
    if (day === 3 && year === 1) {
      return LocoCards[1];
    }
    if (day === 2 && year === 1) {
      return LocoCards[2];
    }
    if (day === 1 && year === 2) {
      return LocoCards[3];
    }
    if (day === 0 && year === 2) {
      return LocoCards[4];
    }
    return LocoCards[0];
  }, "calcPathTrains": (path) => {
    let trainsCount = 0;
    let locoPlaces = path.locoPlaces;
    for (let i = 0; i < locoPlaces.length; i++) {
      let locoPlace = locoPlaces[i];
      trainsCount += locoPlace.currentTrainIDs.length;
    }
    return trainsCount;
  }, "repairLocomotive": (loco) => {
    loco.state = RepairValue;
  }, "processTrains": (path, locoPlace, train) => {
    let nextStation = -1;
    for (let j = 0; j < train.locomotives.length; j++) {
      let loco = GameData.CurrentGame.getLocoById(train.locomotives[j]);
      let prevStation = loco.parentStation;

      for (let i = 0; i < locoPlace.connectedStations.length; i++) {
        if (prevStation !== locoPlace.connectedStations[i]) {
          nextStation = locoPlace.connectedStations[i];
          break;
        }
      }
      loco.parentStation = nextStation;
      if (loco.isHot) {
        loco.state -= 1;
      }
    }
    let station = GameData.CurrentGame.getStationByID(nextStation);
    for (let i = 0; i < train.carTrainPacks.length; i++) {
      let carPack = GameData.CurrentGame.getTrainCarById(train.carTrainPacks[i]);
      if (carPack.type === EMPTY_TRAIN_CAR_TYPE) {
        station.trainCars += carPack.trainCarCount;
      } else {
        console.log(train.carTrainPacks[i])
        station.trainCarsPacks.push(train.carTrainPacks[i]);
      }

    }

    station.locoBrigades += 1;
    GameData.CurrentGame.removeTrainById(train.id);

  }, "processStationCard": (card) => {
    GameData.CurrentGame.removeBrigadeChips(card.type, card.id, card.value);
  }, "processPathCard": (card) => {
    GameData.CurrentGame.addBreakdownChips(card.pathID);
  }, "processLocoCard": (card) => {
    GameData.CurrentGame.processLocoBreakdown(card.pathsID, card.stateCondition);
  }, "processSecurityCard": (card) => {
    let effect = card.levelSecurityCardEffects[GameData.CurrentGame.getSecurityLevel()];
    GameData.CurrentGame.processSecurityCards(card.pathIDs, effect.expenses, effect.brigadeChips, effect.powerChips);
  }, "calculateAvailableStationBrigadesChips": (station) => {
    let cardPacks = station.trainCarsPacks;
    let orderPacks = station.orderTrainPacks;
    let brigadeChips = station.brigadesChips + station.additionalChips + GameData.CurrentGame.getRentedBrigades("station", station.id) * 4;
    for (let i = 0; i < cardPacks.length; i++) {
      let card = GameData.CurrentGame.getTrainCarById(cardPacks[i]);
      if (card.isPreparing) {
        brigadeChips -= 1;
      }
    }
    for (let i = 0; i < orderPacks.length; i++) {
      let card = GameData.CurrentGame.getOrderTrainCarById(orderPacks[i]);
      if (card && card.trainCarCount !== 0) {
        brigadeChips -= Math.ceil(card.trainCarCount / TRAIN_CAR_CARD_MAX_CARS);
      }
    }
    if (brigadeChips < 0) brigadeChips = 0;
    return brigadeChips;
  }, "calculateRepairBrigadeChips": (repairShop, currentGame = GameData.CurrentGame) => {
    let repairingLocomotivesCount = currentGame.locomotives.filter(loco => loco.partsType === repairShop.partsType && loco.isReparing).length;
    let res = repairShop.brigadesChips + repairShop.additionalChips + currentGame.getRentedBrigades("reairshop", repairShop.id) * 4 - repairingLocomotivesCount;
    if (res < 0) res = 0;
    return res;
  }, "calculateParts": (repairShop, currentGame = GameData.CurrentGame) => {
    let repairingLocomotivesCount = currentGame.locomotives.filter(loco => loco.partsType === repairShop.partsType && loco.isReparing).length;
    return repairShop.partsCount - repairingLocomotivesCount;
  }, "calculateAvaliablePartsPath": (repairShop, currentGame = GameData.CurrentGame) => {
    let paths = currentGame.paths;
    let forRepair = 0;
    for (let i = 0; i < paths.length; i++) {
      forRepair += paths[i].forRepairChips;
      forRepair += paths[i].forRepairBreawdownChips;
    }

    return repairShop.partsCount - forRepair;
  }, "calculateCurrentThroughput": (path) => {
    return path.throughput - (path.breakDownChips - path.forRepairBreawdownChips) * 20;
  }, "calculateAvaliableBrigadesChipsPath": (repairShop, currentGame = GameData.CurrentGame) => {
    let paths = currentGame.paths;
    let forRepair = 0;
    for (let i = 0; i < paths.length; i++) {
      forRepair += paths[i].forRepairChips;
      forRepair += paths[i].forRepairBreawdownChips;
    }

    const repairShopWorkersAmount = repairShop.brigadesChips + repairShop.additionalChips;
    const rentedBrigadesTimes4 = currentGame.getRentedBrigades("reairshop", repairShop.id) * 4;
    return repairShopWorkersAmount + rentedBrigadesTimes4 - forRepair;
  }, "calculateAvailableLocoBrigades": (station) => {
    const contractorsTrains = GameData.CurrentGame.getStationTrains(station.id).filter(el => el.isBrigadeContractors);
    const contractorsAmount = station.contractors > 0 ? station.contractors - contractorsTrains.length : 0;
    return station.locoBrigades + contractorsAmount;
  }, calcTrainCars: train => {
    let trainCarsCount = 0;
    if (train.carTrainPacks != null) {
      for (let i = 0; i < train.carTrainPacks.length; i++) {
        trainCarsCount += GameData.CurrentGame.getTrainCarById(train.carTrainPacks[i]).trainCarCount;
      }
    }
    return trainCarsCount;
  }, calcTrainWeight: train => {
    let weight = 0;
    if (train.carTrainPacks) {
      for (let i = 0; i < train.carTrainPacks.length; i++) {
        let pack = GameData.CurrentGame.getTrainCarById(train.carTrainPacks[i]);
        weight += pack.trainCarCount * CargoWeight(pack.type);
      }
    }

    for (let i = 0; i < train.locomotives.length; i++) {
      let loco = GameData.CurrentGame.getLocoById(train.locomotives[i]);
      if (!loco.isHot) weight += LOCO_WEIGHT[loco.partsType];
    }
    return weight;
  }, "calculateAvailablePathThroughput": ({ path, gameData = GameData.CurrentGame, teamID }) => {
    let weight = 0;

    if (path.currentTrainIDs.length > 0) {
      for (let j = 0; j < path.currentTrainIDs.length; j++) {
        let train = gameData.getTrainById(path.currentTrainIDs[j]);
        if (!train) {
          if (teamID) {
            agent.GamePlay.removeTrainFromPath(teamID, {
                pathId: path.id,
                trainId: path.currentTrainIDs[j]
              },
              response => {
                console.log(response)
                window.location.reload();
              });
          } else {
            alert('Произошла ошибка, Тренер должен откатить фазу');
          }
          return;
        }

        weight += train.getTrainCarWeight(gameData);
      }
    }

    return GameController.calculateCurrentThroughput(path) - weight - ((path.endDayBreakdownChips ?? 0) + path.forRepairChips) * 20;
  }, "setTrainToPath": (teamId, pathId, trainId) => {

    let path = GameData.CurrentGame.getPathByID(pathId);
    let train = GameData.CurrentGame.getTrainById(trainId);

    if (train.locoType === ELECTRO_TYPE && path.locoType !== train.locoType) {
      alert("Электровоз не может перемещаться по пути без электрификации");
      return;
    }
    if (path.trainType < train.trainType) {
      alert("Тип поезда не совпадает с типом пути (длина состава)");
      return;
    }
    if (GameController.calculateAvailablePathThroughput({
      path,
      teamID: window.teamID
    }) < GameController.calcTrainCars(train)) {
      alert("Пропускной способности недостаточно")
      return;
    }
    if (!path.connectedStations.includes(train.parentStationID)) {
      alert("Данный путь не связан с текущей станцией")
      return;
    }

    if (path.currentTrainIDs.indexOf(trainId) >= 0) {
      alert("Ошибка постановки поезда. Перезагрузите страницу");
      return;
    }

    let reservedPlaces = 0;
    let canMove = true;
    let trainStart = {}

    if (path.currentTrainIDs.length > 0) {
      let firstTrain = GameData.CurrentGame.getTrainById(path.currentTrainIDs[0]);
      canMove = firstTrain.parentStationID === train.parentStationID || pathId === 5;

      for (let i = 0; i < path.currentTrainIDs.length; i++) {
        let tmpTrain = GameData.CurrentGame.getTrainById(path.currentTrainIDs[i]);
        reservedPlaces += tmpTrain.trainType === 0 ? 1 : 2;

        if (path.id === 5) {
          if (!trainStart[tmpTrain.parentStationID]) {
            trainStart[tmpTrain.parentStationID] = 0;
          }
          trainStart[tmpTrain.parentStationID]++;
        }

        if (!canMove) {
          break;
        }
      }
    }

    const trainWeight = train.trainType === 0 ? 1 : 2;

    if (reservedPlaces + trainWeight > path.locoPlaces) {
      alert("На пути нет места для этого поезда!");
      return;
    }

    if (!canMove) {
      alert("Поезда на пути не могут ехать в разные стороны");
      return;
    }

    if (path.id === 5) {
      let max = 0;
      let canPlaceDestination = true;
      Object.keys(trainStart).forEach(key => {
        max += trainStart[key];
      });
      let anotherKey = null;
      if (max === 6) {
        alert("Максимальное число поездов");
        return;
      }
      Object.keys(trainStart).forEach(key => {
        if (Number(key) !== train.parentStationID) {
          anotherKey = key;
        }
      });
      if (anotherKey) {
        canPlaceDestination = (trainStart[train.parentStationID] ?? 1) < 3 && trainStart[anotherKey] <= 3;
      }
      if (!canPlaceDestination) {
        alert("На данном пути при движении в разные стороны только 3 поезда могут ехать в одну сторону");
        return;
      }
    }

    agent.GamePlay.setTrainToPath(teamId, {
      pathId: pathId, trainId: trainId
    }, response => console.log(response));

  }, calculateStatistics: (gameData, currentGame = GameData.CurrentGame) => {
    // Расчёты
    let totalWeight = 0;
    let debit = gameData.startYearDebet;
    let otherRevenue = gameData.otherRevenue;
    let profit = debit + otherRevenue;

    let nettoWeight = 0;
    let delivered = gameData.deliveredTrainCarWeight;
    for (let c in delivered) {
      if (delivered.hasOwnProperty(c)) {
        let order = gameData.getOrderWithCode(c);

        if (order) {
          let weight = delivered[c];

          nettoWeight += weight;
          totalWeight += weight * 365 / 4;
          let moneyOrder = order.cost * weight * 365 / 4;
          profit += moneyOrder * (1 - order.credit);
        }
      }
    }

    let dieselExpanses = 0;
    let electricityExpanses = 0;

    let fuelMetaData = gameData.currentFuelMetaData;
    for (let locoType in fuelMetaData) {
      for (let pathID in fuelMetaData[locoType]) {
        if (fuelMetaData[locoType].hasOwnProperty(pathID)) {
          let path = gameData.getPathByID(Number(pathID));
          let weight = fuelMetaData[locoType][pathID];
          if (path) {
            if (locoType === LOCO_TYPE) {
              dieselExpanses += GET_FUEL_COST * weight * GetPathLength(Number(pathID)) * 365 / 4;
            } else {
              electricityExpanses += GET_ELECTRICITY_COST * weight * GetPathLength(Number(pathID)) * 365 / 4;
            }
          }
        }
      }
    }
    let fuelExpanses = dieselExpanses + electricityExpanses;

    let valProfit = profit - fuelExpanses;

    let brigadesExpanses = gameData.getTotalBrigades() * GetBrigadeSalary() * (gameData.day + 1) / 4 + gameData.brigadesExpanses;
    let contractorsExpenses = gameData.contractorsExpenses;
    let partsExpanses = gameData.partsExpanses;
    let communicationExpanses = gameData.currentArrivedTrainsCount * 8000 * 365 / 4;
    let otherExpanses = gameData.otherExpanses;
    let securityExpanses = GetSecurityExpanses(gameData.securityLevel) * (gameData.day + 1) / 4 + gameData.securityExpanses;
    let operationsSum = brigadesExpanses + contractorsExpenses + partsExpanses + communicationExpanses + otherExpanses + securityExpanses;

    let EBITDA = valProfit - operationsSum;
    // ОС * 10%/день недели (4,3,2,1)
    let yearlyDeprecation = gameData.fixedAssets * 0.1 / 4;
    let depreciation = (gameData.day + 1) * yearlyDeprecation;
    // На протяжении года берем поквартально. В балансе же нужно показать значение "за прошлый год"
    // то есть вернуть снятые на беке 10% из ОС, и узнать 10% от полной суммы
    if (currentGame.state === 0 && currentGame.day === 0) {
      depreciation = (gameData.fixedAssets + (gameData.fixedAssets * 0.1 / 0.9)) * 0.1;
    }
    let operationalProfit = EBITDA - depreciation;

    let creditPercents = gameData.credit * 0.1 + (gameData.state === 0 ? gameData.creditors : gameData.startYearCreditors);

    let beforeTaxesProfit = operationalProfit - creditPercents;
    let tax = beforeTaxesProfit * 0.3;
    let afterTaxesProfit = tax < 0 ? 0 : tax;
    let cleanProfit = beforeTaxesProfit - afterTaxesProfit;
    let partsSum = gameData.repairShops.reduce((acc, cur) => acc + cur.partsCount, 0) * 1000000;
    let lastYearProfit = gameData.retainedEarnings;

    // Balance section
    let creditBalance = currentGame.credit;
    let creditDebt = gameData.creditors;

    let main = gameData.fixedAssets;
    let mainLeft = main;
    debit = gameData.debet;
    let cash = currentGame.cash;
    let money = partsSum + debit + cash;
    let actives = mainLeft + money;

    let funders = 100000000;

    // Если налика больше, чем кредитов – 0, иначе сумма
    let creditsSum = gameData.cash > creditBalance ? 0 : creditBalance + creditDebt;
    let lastYearProfitBalance = actives - funders - creditsSum;
    let fullCapital = funders + lastYearProfitBalance;
    let passives = creditsSum + fullCapital;

    let cleanCapital = partsSum + debit - creditDebt;
    let debtAbility = fullCapital - creditsSum;
    if (debtAbility > gameData.fixedAssets) debtAbility = gameData.fixedAssets;
    if (debtAbility < 0) debtAbility = 0;

    let cleanCredit = creditsSum < cash ? 0 : creditsSum - cash;

    // Чистые заимствования = Если размер кредитов и займов больше чем наличные, то "Кредиты и займы - Наличные", иначе 0
    let debtCreditsSum = creditsSum > cash ? creditsSum - cash : 0;
    let debtPercent = Math.round(debtCreditsSum / fullCapital * 100);
    //Key Params Section

    let deliveredCargo = totalWeight;
    let npsData = gameData.nps;
    let npsCoal = npsData.coal;
    let npsOther = npsData.other;
    let expData = gameData.exp;
    let expCoal = expData.coal;
    let expOther = expData.other;

    let debtDays = debit / profit * 365;

    let partsDays = Math.round(gameData.startYearParts / gameData.boughtParts * 365);
    let creditDays = Math.round(creditDebt / (fuelExpanses + electricityExpanses + contractorsExpenses * 0.5 + communicationExpanses + otherExpanses + securityExpanses) * 365);
    let capitalYears = main / depreciation;
    let allActives = actives / profit;

    let ROA = Math.round(operationalProfit / actives * 100) + "%";
    let ROE = Math.round(cleanProfit / fullCapital * 100) + "%";

    let avgTonnage = parseFloat((profit / deliveredCargo).toFixed(2));
    let grossMargin = parseFloat((valProfit / profit).toFixed(2));
    let EBITDAPercent = parseFloat((isFinite(EBITDA / profit) ? EBITDA / profit : 0).toFixed(2));
    let operatingProfit = parseFloat((operationalProfit / profit).toFixed(2));
    let netProfit = parseFloat((cleanProfit / profit).toFixed(2));

    let ROCE = Math.round(netProfit / allActives * 100);

    let securityLevel = gameData.securityLevel;
    let investments = 0;
    let receivedDebt = gameData.startYearCreditors - gameData.creditors;

    let allBrigades = gameData.totalBrigadeChips;
    let unusedBrigades = gameData.unUsedBrigadeChips;
    let usedBrigades = allBrigades - unusedBrigades;
    if (usedBrigades > allBrigades) {
      console.log("Внимание! Бригад потрачено больше, чем было!");
      console.log(allBrigades, usedBrigades);
    }
    let brigadesUsage = usedBrigades / allBrigades;
    let unusedMoney = unusedBrigades === 0 ? 0 : brigadesExpanses * (1 - brigadesUsage);

    // Использование локо
    let locoUsage = (gameData.thisYearLocosUsed * 24 * 365 / 4) / gameData.locomotives.length / 365 / 24 * 100;
    locoUsage = parseFloat(locoUsage.toFixed(2)) + "%";

    // Порожний пробег
    let bruttoWeight = gameData.bruttoDeliveredCarWeight;
    let emptyMilesPercent = parseFloat((nettoWeight / bruttoWeight * 100).toFixed(2)) + "%";
    return {
      totalWeight: totalWeight,
      profit: profit,
      otherRevenue: otherRevenue,
      dieselExpanses: dieselExpanses,
      electricityExpanses: electricityExpanses,
      fuelExpanses: fuelExpanses,
      valProfit: valProfit,
      brigadesExpanses: brigadesExpanses,
      contractorsExpenses: contractorsExpenses,
      partsExpanses: partsExpanses,
      communicationExpanses: communicationExpanses,
      otherExpanses: otherExpanses,
      securityExpanses: securityExpanses,
      operationsSum: operationsSum,
      EBITDA: EBITDA,
      depreciation: depreciation,
      operationalProfit: operationalProfit,
      creditPercents: creditPercents,
      beforeTaxesProfit: beforeTaxesProfit,
      afterTaxesProfit: afterTaxesProfit,
      cleanProfit: cleanProfit,
      lastYearProfit: lastYearProfit,
      main: main,
      mainLeft: mainLeft,
      partsSum: partsSum,
      debit: debit,
      cash: cash,
      money: money,
      actives: actives,
      cleanCredit: cleanCredit,
      fullCapital: fullCapital,
      credit: creditBalance,
      creditDebt: creditDebt,
      creditsSum: creditsSum,
      funders: funders,
      passives: passives,
      cleanCapital: cleanCapital,
      debtAbility: debtAbility,
      deliveredCargo: deliveredCargo,
      npsCoal: npsCoal,
      npsOther: npsOther,
      expCoal: expCoal,
      expOther: expOther,
      debtDays: debtDays,
      partsDays: partsDays,
      creditDays: creditDays,
      capitalYears: capitalYears,
      allActives: allActives,
      ROA: ROA,
      ROE: ROE,
      ROCE: ROCE,
      securityLevel: securityLevel,
      investments: investments,
      receivedDebt: receivedDebt,
      avgTonnage: avgTonnage,
      grossMargin: grossMargin,
      EBITDAPercent: EBITDAPercent,
      operatingProfit: operatingProfit,
      netProfit: netProfit,
      brigadesUsage: brigadesUsage,
      unusedBrigades: unusedBrigades,
      unusedMoney: unusedMoney,
      lastYearProfitBalance: lastYearProfitBalance,
      creditBalance: creditBalance,
      debtPercent: debtPercent,
      locoUsage: locoUsage,
      emptyMilesPercent: emptyMilesPercent
    }
  }, calculateCargoWeight(carPacIDs, gameData = GameData.CurrentGame) {
    let carPacs = carPacIDs.map(id => gameData.getTrainCarById(id));
    let packsWeights = {};
    let weight = 0;

    if (!carPacs.length) return 0;

    // Суммируем веса согласно таблице
    for (let el of carPacs) {
      let weight = CargoWeight(el.type);
      if (packsWeights[weight]) packsWeights[weight] += el.trainCarCount; else packsWeights[weight] = el.trainCarCount;
    }

    // Прибавляем вес и ищем максимальный показатель веса
    let maxValue = 0;
    for (let key in packsWeights) {
      weight += parseInt(key) * packsWeights[key];

      if (parseInt(key) > maxValue) maxValue = parseInt(key);
    }

    return Math.round(weight / maxValue);
  }, checkPath4Locos: (path, gameData) => {
    let everyTrainHasRightLoco = true;

    for (let trainID of path.currentTrainIDs) {
      let trainInfo = gameData.getTrainById(trainID);
      let trainHasRightLocoTypes = true;

      for (let locoID of trainInfo.locomotives) {
        let loco = gameData.getLocoById(locoID);

        if (loco.movementType !== path.locoType && loco.isHot) {
          trainHasRightLocoTypes = false;
          break;
        }
      }

      if (!trainHasRightLocoTypes) {
        everyTrainHasRightLoco = false;
        break;
      }
    }

    if (!everyTrainHasRightLoco) {
      return {
        status: false, error: "На пути №5 электровоз не может быть локомотивом"
      };
    }
    return everyTrainHasRightLoco;

  }, validateEndEvening: (gameData, trains, currentPath = null) => {
    for (let train of trains) {
      // Если в поезде нет локо, но есть груз
      if (train.carTrainPacks.length && !train.locomotives.length) {
        return {
          status: false, error: `В поезде №${train.id + 1} есть груз, но нет локомотива!`
        };
      }
      let id = train.id + 1;

      let locos = train.locomotives.map(el => gameData.getLocoById(el));
      let cargos = train.carTrainPacks.map(el => gameData.getTrainCarById(el));
      let allCargoIsEmpty = cargos.filter(el => el.type === "empty").length === cargos.length;

      if (!locos.length) continue;

      let isHot = 0;
      let cargoWeight = GameController.calculateCargoWeight(train.carTrainPacks, gameData);

      for (let loco of locos) {
        if (loco.isHot) isHot++;
      }

      let locoLifting = allCargoIsEmpty ? 40 : 30;
      let electroLifting = allCargoIsEmpty ? 70 : 40;

      let canLift = locos[0].partsType === "electro" ? electroLifting : locoLifting;
      canLift *= isHot;

      if (isHot === 0) {
        return {
          status: false, error: `В составе №${id} должен быть хотя бы один ведущий локомотив!`
        };
      }

      if (canLift < cargoWeight && locos.length) {
        return {
          status: false,
          error: `Локомотив в поезде №${id} не может увезти столько груза! Отправьте лишний груз в тупик!`
        };
      }

      if (!currentPath) {
        for (let path of gameData.paths) {
          if (GameController.calculateAvailablePathThroughput({
            path,
            gameData,
            teamID: window.teamID,
          }) < 0) {
            let hasTrainCars = false;

            // Если на этом пути есть поезда
            for (let el of path.currentTrainIDs) {
              let currentTrainData = gameData.getTrainById(el);
              if (currentTrainData.carTrainPacks.length) {
                hasTrainCars = true;
                break;
              }
            }

            if (hasTrainCars) return {
              status: false, error: `На пути №${path.id} отрицательная грузоподъемность!`
            }
          }

          if (path.id === 5) {
            let everyTrainHasRightLoco = GameController.checkPath4Locos(path, gameData);

            if (!everyTrainHasRightLoco) {
              return {
                status: false, error: "На пути №5 электровоз не может быть ведущим локомотивом"
              };
            }
          }
        }
      } else {
        if (GameController.calculateAvailablePathThroughput({
          path: currentPath,
          gameData,
          teamID: window.teamID,
        }) < 0) {
          let hasTrainCars = false;

          if (hasTrainCars) return {
            status: false, error: `На пути отрицательная грузоподъемность!`
          }
        }
        console.log(currentPath);
        if (currentPath.id === 5) {
          let everyTrainHasRightLoco = GameController.checkPath4Locos(currentPath, gameData);

          if (!everyTrainHasRightLoco) {
            return {
              status: false, error: "На пути №5 электровоз не может быть ведущим локомотивом"
            };
          }
        }
      }
    }

    return {
      status: true
    };
  }, validateTrainsOnStation(gameData = GameData.CurrentGame) {
    let stationNames = {};
    let trains = [];

    for (let train of gameData.currentTrains) {
      if (!gameData.isTrainOnAnyPath(train)) {
        stationNames[STATION_NAMES[train.parentStationID]] = 1;
        trains.push(train.id);
      }
    }

    let size = Object.keys(stationNames).length;

    if (size) {
      let message = size > 1 ? "й " : "и ";
      message += Object.keys(stationNames).join(", ");

      let error = `Вы никуда не отправили поезд${trains.length > 1 ? "а" : ""} со станци${message}! Вы уверены что хотите завершить фазу? Это действие отменить будет нельзя.`;
      return {
        status: false, trains: trains, error
      }
    }

    return {
      status: true
    }
  }, freeAllTrainsOnStations(teamID, trains, gameData = {}) {
    // В цикле запросы отправляются слишком быстро, данные не успевают обновиться,
    // поэтому запросы идут по таймауту
    let counter = 10;
    for (let trainId of trains) {
      if (!gameData.isTrainOnAnyPath(trainId)) {
        setTimeout(() => {
          agent.GamePlay.freeTrain(teamID, {trainId}, console.log);
        }, counter);
        counter += 100;
      }
    }
  }, sameCard: function (currentProps, newProps) {
    let equal = true;

    if (Object.keys(currentProps).length !== Object.keys(newProps).length) return;

    for (let key in currentProps) {
      if (currentProps.hasOwnProperty(key)) {
        if (newProps[key] !== undefined) {
          if (key === "parent") continue;

          if (currentProps[key] !== newProps[key]) {
            console.log(key, currentProps[key], newProps[key])
            equal = false;
            break;
          }
        }
      }
    }

    return equal;
  }, getSaveInfo: function (data) {
    const STATES = ["Начало года", ...GAME_STATE_NAMES]

    let day = DAY_NAMES[data.day];
    let year = parseInt(data.year) + 1;
    let state = STATES[data.state];

    return `${day} ${year}Г, ${state}`;
  }
}
export default GameController;
